import { createFileRoute } from "@tanstack/react-router";
import { PaintBrush } from "@phosphor-icons/react";

import { Badge } from "@/components/ui/badge";
import { AdTypes } from "@/components/ai-designer/ad-types";
import { Tools } from "@/components/ai-designer/tools";
import { ChatList } from "@/components/ai-designer/chat-list";
import { ChatComposer } from "@/components/chat/composer";

export const Route = createFileRoute("/dashboard/ai-designer/_layout/create")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-4">
            <span className="rounded-lg bg-muted p-2.5">
              <PaintBrush className="size-5" weight="bold" />
            </span>
            <h2 className="text-2xl font-semibold">AI Designer</h2>
            <Badge className="rounded-full border-0 bg-success/10 text-xs text-success">Agent</Badge>
          </div>
          <p className="text-sm text-muted-foreground pl-14">Studio-quality ad creatives powered by Brand DNA</p>
        </div>
        <ChatComposer context chatSettings placeholder="What would you like to create with Bacon today?" />
      </div>
      <AdTypes />
      <Tools />
      <ChatList />
    </div>
  );
}
